import { useState } from "react";
import { useModerationQueue } from "@/hooks/useModerationQueue";
import { useModerationItem } from "@/hooks/useModerationItem";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { ModerationCard } from "@/components/ModerationCard";
import { ModerationDetailModal } from "@/components/ModerationDetailModal";

export function ModerationQueuePage() {
  useDocumentTitle("Moderation Queue");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data: queue, isLoading, error } = useModerationQueue();
  const { data: itemData } = useModerationItem(selectedId);

  return (
    <div>
      <h1 className="font-headline-lg text-headline-lg text-on-surface mb-stack-md">
        Moderation Queue
      </h1>

      {isLoading && (
        <p className="font-body-md text-on-surface-variant">Loading queue...</p>
      )}

      {error && (
        <p className="font-body-md text-error">Failed to load moderation queue.</p>
      )}

      {queue && queue.length === 0 && (
        <p className="font-body-md text-on-surface-variant">
          No items in the moderation queue. All clear!
        </p>
      )}

      {queue && queue.length > 0 && (
        <div className="space-y-stack-sm">
          {queue.map((item) => (
            <ModerationCard
              key={item.experienceId}
              queueItem={item}
              experience={null}
              onClick={() => setSelectedId(item.experienceId)}
            />
          ))}
        </div>
      )}

      {selectedId && itemData?.experience && (
        <ModerationDetailModal
          queueItem={itemData.queue}
          experience={itemData.experience}
          onClose={() => setSelectedId(null)}
        />
      )}
    </div>
  );
}
